module.exports = __webpack_public_path__ + "img/xiaoyi_zhushou.cd21e9f1.png";